import { useEffect } from 'react';

import Box from '@mui/material/Box';
import Grid2 from '@mui/material/Grid2';
import Container from '@mui/material/Container';
import { useTheme, useMediaQuery } from '@mui/material';

import { useSettingsContext } from 'src/components/settings';

import { SettingsView } from 'src/sections/chat';

import { HEADER, SIDE_NAV } from './layoutConfig';

type Props = {
  children: React.ReactNode;
};

function Main({ children }: Props) {
  const theme = useTheme();
  const settings = useSettingsContext();
  const { openSettings, onCloseSettings } = useSettingsContext();
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));
  const isNavMini = settings.state.navLayout === 'mini';

  // Hide settings panel by default on tablet screens
  useEffect(() => {
    if (isTablet) {
      onCloseSettings();
    }
  }, [isTablet, onCloseSettings]);

  return (
    <Box
      component="main"
      sx={() => ({
        height: `calc(100vh - ${HEADER.H_MOBILE}px)`,
        display: 'flex',
        width: '100%',
        pt: `${HEADER.H_MOBILE}px`,
        pl: {
          md: !isNavMini ? `${SIDE_NAV.W_VERTICAL}px` : `${SIDE_NAV.W_MINI}px`,
          xs: `${SIDE_NAV.W_MINI}`,
        },
        transition: theme.transitions.create(['width', 'padding'], {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.standard,
        }),
      })}
    >
      <Grid2 container height="inherit" width="100%">
        <Grid2 size={openSettings ? 10 : 12} height="inherit">
          <Box sx={{ height: 'inherit' }}>{children}</Box>
        </Grid2>
        {openSettings && (
          <Grid2 size={2} sx={{ borderLeft: `1px dashed rgba(70 80 112 / 0.2)` }}>
            <Container>
              <SettingsView />
            </Container>
          </Grid2>
        )}
      </Grid2>
    </Box>
  );
}

export default Main;
